/* unplugin-vue-components disabled */import script from "./InvoiceAddPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceAddPopup.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceAddPopup.vue?vue&type=style&index=0&id=fe0e7f5c&lang=scss"

const __exports__ = script;

export default __exports__